export const GLOBALTYPES = {
    AUTH: "AUTH",
    ALERT: "ALERT",
    SIGNIN: "SIGNIN",
    UNSUBSCRIBE: "UNSUBSCRIBE"
}